import React, { useState, useRef } from "react";
import FileUpload from "../../../util/FileUpload";

const NewStaffCorrespondence = ({ onSubmit, onCancel }) => {
	// local state
	const [file, setFile] = useState(null);

	// ref
	const name = useRef(null);
	const description = useRef(null);
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				onSubmit({
					name: name.current.value,
					desc: description.current.value,
					path: file
				});
				name.current.value = "";
				description.current.value = "";
				name.current.focus();
			}}
		>
			<div className="form-group">
				<label htmlFor="name-id">File Name</label>
				<input
					type="name-local"
					className="form-control input-height"
					id="name-id"
					required
					ref={name}
					aria-describedby="name-id"
					placeholder="enter name"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="description-id">File Description</label>
				<textarea
					name="description-id"
					id="description-id"
					ref={description}
					className="form-control form-control-textarea"
					required
					rows="4"
					placeholder="enter description"
				></textarea>
			</div>

			<div className="form-group">
				<FileUpload
					title="Attachment File"
					onData={item => setFile(item.path)}
					accept="application/pdf,application/msword,
  application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*"
				/>
			</div>

			<div className="text-center">
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle btn-success"
				>
					Upload Attachment{" "}
					<i className="material-icons">arrow_right_alt</i>
				</button>
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-left-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>
			</div>
		</form>
	);
};

export default NewStaffCorrespondence;
